export const NEW_FILE_MODEL_FORM = "configOpportunityNewFileModelForm";
export const TEMPLATE_FORM = "configOpportunityTemplateForm";
export const TEMPLATE_TEST_FORM = "configOpportunityTemplateTestForm";
export const DELETE_TEMPLATE_FORM = "configOpportunityDeleteTemplateForm";
export const NEW_IMAGE_FORM = "configOpportunityNewImageForm";
export const DELETE_IMAGE_FORM = "configOpportunityDeleteImageForm";